import React from 'react';
import { withRouter } from '../../core/withRouter';
import {observer} from 'mobx-react';
import { PropTypes } from 'prop-types';

@observer
class NewAppCancelContinueSubmit extends React.Component {

	static propTypes = {
		store: PropTypes.object.isRequired,
		match: PropTypes.object.isRequired,
		disabled: PropTypes.bool
	}

	static defaultProps = {
		disabled: false
	}

	constructor(props) {
		super(props);
		this.store = this.props.store;
	}

	onCloseAndGoToMyApps = () => {
		if(!this.props.disabled) {
			this.store.closeAndGotoMyApps();
		}
	};

	onContinue = () => {
		if(!this.props.disabled) {
			this.store.goToNextStep()
		}
	};

	onSaveAndCheckForErrors = () => {
		if(!this.props.disabled) {
			this.store.saveAndCheckForErrors();
		}
	};

	onSaveAndContinue = () => {
		if(!this.props.disabled) {
			this.store.saveStepAndContinue();
		}
	};

	onSubmitApplication = () => {
		if(!this.props.disabled) {
			this.store.submitApplication();
		}
	};

	renderCloseAndGotoMyAppsButton = (disabled = false) => {
		const isDisabled = disabled || this.props.disabled;
		return (
			<button key="btn-cagtma" className="fn-secondary" disabled={isDisabled} onClick={this.onCloseAndGoToMyApps}>
				Close &amp; Go To My Apps
			</button>
		);
	}

	renderSaveAndContinueButton = (disabled = false) => {
		const isDisabled = disabled || this.props.disabled || this.store.masterStateProps.namePlatformIsEditable;
		return (
			<button key="btn-sac" className="fn-primary" disabled={isDisabled} onClick={this.onSaveAndContinue}>
				Save &amp; Continue
			</button>
		);
	}

	renderPartialSaveButton = () => {
		return (
			<button key="btn-ps" className="fn-primary" disabled={true}>
				<span><i className="icon-reload"/>Saving&hellip;</span>
			</button>
		)
	}

	renderSaveAndCheckForErrorsButton = () => {
		const isDisabled = this.props.disabled || this.store.masterStateProps.isSavingAndChecking;
		return (
			<button key="btn-sacfe" className="fn-primary" disabled={isDisabled} onClick={this.onSaveAndCheckForErrors}>
				{this.store.masterStateProps.isSavingAndChecking
					? <span><i className="icon-reload"/>Saving&hellip;</span>
					: <span>Save &amp; Check for Errors</span>
				}
			</button>
		);
	}

	renderContinueButton = () => {
		const isDisabled = this.props.disabled;
		return (
			<button key="btn-c" className="fn-primary" disabled={isDisabled} onClick={this.onContinue}>
				Continue
			</button>
		);
	}

	renderSubmitForApprovalButton = () => {
		const isDisabled = this.props.disabled || !this.store.masterStateProps.userAgreedToTerms;
		return (
			<button key="btn-sfa" className="fn-primary" disabled={isDisabled} onClick={this.onSubmitApplication}>
				Submit App for Approval
			</button>
		);
	}

	renderButtons () {
		let buttonJsx = '';

		if(this.store.masterStateProps.isPartialSaving) {
			buttonJsx = [this.renderPartialSaveButton(), this.renderCloseAndGotoMyAppsButton()];
		} else {
			const currentSection = this.props.match.params.section;
			switch(currentSection) {
				case 'app-details':
				case 'app-package':
					buttonJsx = [this.renderSaveAndContinueButton(), this.renderCloseAndGotoMyAppsButton()];
					break;
				case 'app-screenshots':
					buttonJsx = [this.renderSaveAndCheckForErrorsButton(), this.renderCloseAndGotoMyAppsButton()];
					break;
				case 'app-review':
					buttonJsx = [this.renderContinueButton(), this.renderCloseAndGotoMyAppsButton()];
					break;
				case 'app-submit':
					buttonJsx = [this.renderSubmitForApprovalButton(), this.renderCloseAndGotoMyAppsButton()];
					break;
				default:
					buttonJsx = [this.renderSaveAndContinueButton(true), this.renderCloseAndGotoMyAppsButton(true)];
			}
		}

		return (
			<div className="new-app-footer-buttons">
				{buttonJsx}
			</div>
		);
	}

	render () {
		return(
			<section className={`new-app-cancel-continue-submit ${(this.props.disabled ? 'deactivated' : '')}`}>
				<div className="container">
					<div className="row">
						<div className="col-12">
							{this.renderButtons()}
						</div>
					</div>
				</div>
			</section>
		);
	}

}

export default withRouter(NewAppCancelContinueSubmit);
